import { DatePipe, NgClass } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';

import { AdminRequestService } from '~shared/services/admin-request.service';

@Component({
  selector: 'app-admin-form-request-message',
  imports: [NgClass, DatePipe],
  templateUrl: './admin-form-request-message.component.html',
  styleUrl: './admin-form-request-message.component.css',
})
export class AdminFormRequestMessageComponent {
  adminRequestService = inject(AdminRequestService);
  activeEntries = this.adminRequestService.getRequestLogEntries();
  historyEntries = this.adminRequestService.getRequestLogHistoryEntries();
  isCenterOpen = signal(false);

  visibleToasts = computed(() => this.activeEntries().slice(0, 2));
  queuedToastCount = computed(() => Math.max(0, this.activeEntries().length - this.visibleToasts().length));
  unreadCount = computed(() => this.historyEntries().filter((entry) => !entry.read).length);
  hasVisibleErrorToast = computed(() => this.visibleToasts().some((entry) => entry.severity === 'error'));
  latestCriticalEntry = computed(
    () => this.historyEntries().find((entry) => entry.severity === 'error' && !entry.read) ?? null
  );
  recentHistory = computed(() => this.historyEntries().slice(0, 30));

  dismiss(id: number) {
    this.adminRequestService.dismissRequestLogEntry(id);
  }

  clearAll() {
    this.adminRequestService.clearAllRequestLogEntries();
  }

  toggleCenter() {
    const nextState = !this.isCenterOpen();
    this.isCenterOpen.set(nextState);
    if (nextState) {
      this.adminRequestService.markAllAsRead();
    }
  }

  closeCenter() {
    this.isCenterOpen.set(false);
    this.adminRequestService.markAllAsRead();
  }
}
